import { PropsWithChildren, useRef } from 'react'
import { TbPencil } from 'react-icons/tb'
import { v4 as uuid } from 'uuid'

import { Tooltip } from 'components/Tooltip'
import { WorkspaceLogo } from 'routes/components/WorkspaceLogo'
import { css } from 'styled-system/css'
import { Icon } from 'ui-kit/icon'
import { FormLabel } from 'ui-kit/styled/form-label'
import clsx from 'utils/clsx'

import classes from './WorkspaceLogoUploader.module.css'

export function WorkspaceLogoUploader({ logoUri, onUpload, className }) {
  return (
    <div className={clsx(classes.logoUploader, className)}>
      <FileUploaderMaskButton onUpload={onUpload}>
        <Tooltip tooltip={'Click to change logo'}>
          <span className={classes.logoUploader_button}>
            <Icon>
              <TbPencil />
            </Icon>
          </span>
        </Tooltip>
      </FileUploaderMaskButton>
      <WorkspaceLogo logoUri={logoUri} />
    </div>
  )
}

export function FileUploaderMaskButton({
  children,
  onUpload,
}: PropsWithChildren<{
  onUpload: (imgBase64: string) => void
}>) {
  const uid = useRef(uuid())

  function handleChange(e) {
    const reader = new FileReader()

    reader.onload = function (e) {
      // FIXME: strictNullCheck temporary fix
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      onUpload(e.target.result as string)
    }

    reader.readAsDataURL(e.target.files[0])
  }

  return (
    <FormLabel cursor='pointer' htmlFor={`uploadFile_${uid.current}`}>
      {children}
      <input
        id={`uploadFile_${uid.current}`}
        type='file'
        multiple={false}
        accept={'image/*'}
        onChange={handleChange}
        className={css({
          display: 'none',
        })}
      />
    </FormLabel>
  )
}
